








































import {
  BLink,
  BNavbar,
  BNavbarNav,
  BNavbarBrand,
  BImg,
  // BNavForm,
  // BFormInput,
  BNavbarToggle,
  BNavText,
  // BNavItem,
  BCollapse,
} from 'bootstrap-vue';
import { computed, reactive } from '@vue/composition-api';
import store from '../store';
import axios from 'axios';
// import router from '../router';
export default {
  name: 'Navbar',
  components: {
    BLink,
    BNavbar,
    BNavbarNav,
    BImg,
    // BNavForm,
    // BFormInput,
    BNavbarToggle,
    BNavText,
    // BNavItem,
    BCollapse,
  },
  setup() {
    const decks = computed(() => store.state.decksMod.decks);

    const openBucket = (link: string) => {
      const bucketLink = store.state.authMod.bucketUrl;
      console.log('bucketlink', bucketLink);

      window.open(bucketLink, '_blank');
    };
    const viewDeck = (deckID: string) => {
      const threadView = `https://${store.state.authMod.threadIDStr}.thread.hub.textile.io/Deck/`;

      window.open(threadView + deckID);
    };
    const loggedIn = computed(() => store.getters.authMod.loggedIn);
    const syncing = computed(() => store.getters.authMod.syncing);
    const logout = () => {
      store.dispatch.authMod.logout();
      store.commit.authMod.LOGGEDIN(false);
    };
    const saveToChain = () => {
      store.dispatch.decksMod.saveDecksToChain();
    };

    return { loggedIn, syncing, logout, openBucket, decks, viewDeck, saveToChain };
  },
};
